import type { FaireProductEntity } from "../../entity_types/product";

export const p_2vg87g9hff: FaireProductEntity = {
  token: "p_2vg87g9hff",
  type: "product",
  name: "Baseball Stitches Leopard Hat",
  brandToken: "b_7gu2z523yj",
  brandName: "P&PD Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/600774ddec039f1c7fe82fead9e614d56edb91b5ed87bd33f3743e0cc8ee4d60.webp",
  galleryImageUrls: [],
  priceDollars: 18,
  description:
    "Embroidered on unisex hats\n\nAdjustable, Snap-back\n\nTAT: 5-10 BD\n\nNo Minimums\n",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:38.929Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
